










































import { Vue, Component, Prop } from 'vue-property-decorator'
import { ActionDef } from './type'

import iIcon from '@/components/base/iIcon.vue'

@Component({
  components: {
    iIcon
  }
})
export default class ActionDropdown<T> extends Vue {
    @Prop()
    readonly dataItems!:ActionDef<T>[]

    @Prop({ default: false })
    tableActionIcon?:boolean

    onSelectAction (key:string) {
      const actionRes = this.dataItems.filter(item => {
        return item.name === key
      })
      if (actionRes) {
        const action = actionRes[0]
        action._dropDownClick && action._dropDownClick()
      }
    }
}
